import { useTranslation } from 'react-i18next';
import { isRetriableNetworkError } from 'BackRoyalApi';
import '../locales/studentNetworkV2/studentNetworkV2-en.json';

type NetworkErrorCardProps = {
    error: unknown;
    onRetry: () => void;
};

export function NetworkErrorCard({ error, onRetry }: NetworkErrorCardProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'studentNetworkV2.studentNetworkV2.errors' });
    const message = isRetriableNetworkError(error) ? t('requestFailed') : t('somethingWentWrong');

    return (
        <div className="flex flex-col items-center gap-4 py-12 text-center">
            <p className="text-base italic text-slate-grey">{message}</p>
            <button
                type="button"
                onClick={onRetry}
                className="rounded-full border border-slate-grey-200 bg-slate-grey-100-alt px-6 py-2.5 text-sm font-medium text-black transition-colors hover:bg-slate-grey-100"
            >
                {t('retry')}
            </button>
        </div>
    );
}
